const VERSION = {
  countToCompare: 2,
};

export default VERSION;
